import React from 'react'
import { SVGProps } from 'react'

const EditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={13}
    height={12}
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M4.43669 10.499L1.71487 7.77721L8.29805 1.19404L11.0199 3.91585L4.43669 10.499ZM1.46046 8.25666L3.95724 10.7534L0.213867 12L1.46046 8.25666ZM11.857 3.0823L11.3849 3.55439L8.6595 0.828983L9.1316 0.356884C9.60716 -0.118961 10.3783 -0.118961 10.8539 0.356884L11.857 1.36C12.3291 1.83715 12.3291 2.6053 11.857 3.0823Z" />
    </g>
  </svg>
)
export default EditIcon
